export default function getDefaultLevel(classDataParam = {}) {
  const classData = JSON.parse(JSON.stringify(classDataParam));
  const defaultLevel =
    classData.students?.pop()?.classStudent.level || classData.level || 'easy';
  return { medium: 'normal', hard: 'difficult' }[defaultLevel] || defaultLevel;
}
